/* RSF Newsletter — inline form su /pages/subscribe.
   AJAX POST a /contact (Shopify nativo customer form), no reload.
   Success → state success inline con codice NL10OFF.
*/
(function () {
  'use strict';

  function wrap() { return document.getElementById('rsf-subscribe-form-wrap'); }
  function setState(name) {
    var w = wrap();
    if (!w) return;
    ['form', 'success', 'error'].forEach(function (s) {
      var el = w.querySelector('[data-rsf-nl-state="' + s + '"]');
      if (!el) return;
      if (s === name) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  /* Click handlers globali (retry, copy) */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-rsf-nl-retry]')) {
      e.preventDefault();
      setState('form');
      return;
    }
    var copyBtn = e.target.closest && e.target.closest('[data-rsf-nl-copy]');
    if (copyBtn) {
      e.preventDefault();
      var code = copyBtn.getAttribute('data-rsf-nl-copy');
      try {
        navigator.clipboard.writeText(code);
        var orig = copyBtn.textContent;
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = orig; }, 1500);
      } catch (err) {}
    }
  });

  /* AJAX submit del form */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'rsf-nl-form') return;
    e.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.origText = submitBtn.textContent;
      submitBtn.textContent = 'Submitting…';
    }

    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { params.append(k, v); });

    fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'text/html, application/xhtml+xml'
      },
      body: params.toString(),
      credentials: 'same-origin',
      redirect: 'follow'
    })
    .then(function (r) { return r.text().then(function (t) { return { status: r.status, text: t }; }); })
    .then(function (res) {
      if (res.status >= 400) throw new Error('HTTP ' + res.status);
      var html = res.text;
      if (html.indexOf('contact_form-error') !== -1 ||
          html.indexOf('form__message--error') !== -1 ||
          /class="[^"]*form-errors[^"]*"/i.test(html)) {
        var msg = (html.match(/<li[^>]*>([^<]*email[^<]*)<\/li>/i) || [])[1] || 'Please check your email and try again.';
        var msgEl = document.querySelector('[data-rsf-nl-error-msg]');
        if (msgEl) msgEl.textContent = msg.replace(/<[^>]+>/g, '').trim();
        setState('error');
      } else {
        setState('success');
        /* Scroll top in caso form lungo */
        var w = wrap();
        if (w && w.scrollIntoView) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    })
    .catch(function () {
      setState('error');
    })
    .then(function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.origText || 'Yes, I\'d love 10€ off!';
      }
    });
  }, true);
})();
